import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-initiative-milestones',
  templateUrl: './initiative-milestones.component.html',
  styleUrls: ['./initiative-milestones.component.scss'],
})
export class InitiativeMilestonesComponent implements OnInit {
  @Input() initiative_data: any;
  @Input() filters_data: any;

  user_details: any;

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public dateFormate: DatePipe,
    private storageService: StorageService,
  ) {}

  ngOnInit(): void {
    this.user_details = this.storageService.get('user_details');
    this.getMilestones();
    this.getTaggingUsers();
    this.getOwners();
    this.getInitiativePriorities();
    this.getCommunicationTypes();
    this.getStatusList();
    this.getAppointmentStatusList();
  }

  tagging_users_list: any = [];
  getTaggingUsers() {
    this.commonService.getData('/taguserslist/').subscribe(
      (res: any) => {
        this.tagging_users_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  owners_list: any = [];
  getOwners() {
    this.commonService
      .getData('/getowner/')
      .subscribe(
        (res: any) => {
          this.owners_list = res;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  prority_list: any = [];
  getInitiativePriorities() {
    this.commonService.getData('/initiativePriority?no_page=true').subscribe(
      (res: any) => {
        this.prority_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  milestones_data: any = [];
  getMilestones() {
    this.show_milestone_tasks = null;

    this.milestones_data = [];
    this.commonService
      .getData(
        '/milestone/?initiative=' +
          this.initiative_data.id +
          '&no_page=true&initiative_owner=true',
      )
      .subscribe(
        (res: any) => {
          this.milestones_data = res;
          for (let index = 0; index < this.milestones_data.length; index++) {
            this.commonService
              .getData(
                '/milestonecomments?milestone=' +
                  this.milestones_data[index].id +
                  '&no_page=true',
              )
              .subscribe(
                (comments: any) => {
                  this.milestones_data[index].comments = [];
                  for (let cIndex = 0; cIndex < comments.length; cIndex++) {
                    this.milestones_data[index].comments.push(comments[cIndex]);
                  }
                },
                (err) => {
                  this.commonService.showToast('error', err.error);
                },
              );
          }
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  getCommentRoute(id) {
    let route = '';
    return route;
  }

  communication_type_list: any = [];
  getCommunicationTypes() {
    this.commonService.getData('/communicationType/?no_page=true').subscribe(
      (res: any) => {
        this.communication_type_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  status_list: any = [];
  getStatusList() {
    this.commonService.getData('/status/?no_page=true').subscribe(
      (res: any) => {
        this.status_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  appointment_status_list: any = [];
  getAppointmentStatusList() {
    // this.commonService.getData("/appointmentStatus/?no_page=true").subscribe(
    this.commonService.getData('/conversionStatus/').subscribe(
      (res: any) => {
        this.appointment_status_list = res['results'];
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  @ViewChild('pageOperationsModal') pageOperationsModal: TemplateRef<any>;
  private pageOperationsModalRef: MatDialogRef<TemplateRef<any>>;

  selected_page_data: any = {
    name: '',
    description: '',
    due_date: '',
    actual_date: '',
    status: '',
    milestone_priority: '',
    milestone_owner: '',
  };
  selected_page_data_errors: any = {
    name: false,
    description: false,
    due_date: false,
    actual_date: false,
    status: false,
    milestone_priority: false,
    milestone_owner: false,
  };
  page_operation_type: any = 'Add';
  page_operation_index: any = null;
  comment_data: any = {
    comment_date: '',
    description: '',
  };
  comment_data_errors: any = {
    comment_date: false,
    description: false,
  };

  openPageOperationModal(data, type, index) {
    this.selected_page_data = JSON.parse(JSON.stringify(data));
    if (
      this.selected_page_data.due_date != null &&
      this.selected_page_data.due_date != ''
    ) {
      this.selected_page_data.due_date = this.dateFormate.transform(
        this.selected_page_data.due_date,
        'MM/dd/yyyy',
      );
    } else {
      this.selected_page_data.due_date = this.dateFormate.transform(
        new Date(),
        'MM/dd/yyyy',
      );
    }

    if (
      this.selected_page_data.actual_date != null &&
      this.selected_page_data.actual_date != ''
    ) {
      this.selected_page_data.actual_date = this.dateFormate.transform(
        this.selected_page_data.actual_date,
        'MM/dd/yyyy',
      );
    } else {
      // this.selected_page_data.actual_date = this.dateFormate.transform(new Date(), "MM/dd/yyyy");
      this.selected_page_data.actual_date = null;
    }

    this.page_operation_type = type;
    this.page_operation_index = index;
    this.pageOperationsModalRef = this.dialog.open(this.pageOperationsModal, {
      disableClose: true,
    });
    this.pageOperationsModalRef.afterClosed().subscribe((result) => {
      this.closeActivityOperationModal();
    });
  }

  closeActivityOperationModal() {
    this.resetModalData();
    this.pageOperationsModalRef.close();
  }

  resetModalData() {
    this.selected_page_data = {
      name: '',
      description: '',
      due_date: '',
      actual_date: '',
      status: '',
      milestone_priority: '',
      milestone_owner: '',
    };
    this.selected_page_data_errors = {
      name: false,
      description: false,
      due_date: false,
      actual_date: false,
      status: false,
      milestone_priority: false,
      milestone_owner: false,
    };
    this.page_operation_type = 'Add';
    this.page_operation_index = null;
    this.comment_data = {
      comment_date: '',
      description: '',
    };
    this.comment_data_errors = {
      comment_date: false,
      description: false,
    };
  }

  saveTask() {
    if (
      this.selected_page_data.name != '' &&
      this.selected_page_data.name != null
    ) {
      this.selected_page_data_errors.name = false;
    } else {
      this.selected_page_data_errors.name = true;
    }

    // if (this.selected_page_data.description != "" && this.selected_page_data.description != null) {
    //   this.selected_page_data_errors.description = false;
    // } else {
    //   this.selected_page_data_errors.description = true;
    // }

    if (
      this.selected_page_data.due_date != '' &&
      this.selected_page_data.due_date != null
    ) {
      this.selected_page_data_errors.due_date = false;
    } else {
      this.selected_page_data_errors.due_date = true;
    }

    // if (this.selected_page_data.actual_date != "" && this.selected_page_data.actual_date != null) {
    //   this.selected_page_data_errors.actual_date = false;
    // } else {
    //   this.selected_page_data_errors.actual_date = true;
    // }

    if (
      this.selected_page_data.milestone_owner != '' &&
      this.selected_page_data.milestone_owner != null
    ) {
      this.selected_page_data_errors.milestone_owner = false;
    } else {
      this.selected_page_data_errors.milestone_owner = true;
    }

    if (
      this.selected_page_data.milestone_priority != '' &&
      this.selected_page_data.milestone_priority != null
    ) {
      this.selected_page_data_errors.milestone_priority = false;
    } else {
      this.selected_page_data_errors.milestone_priority = true;
    }

    if (
      this.selected_page_data.status != '' &&
      this.selected_page_data.status != null
    ) {
      this.selected_page_data_errors.status = false;
    } else {
      this.selected_page_data_errors.status = true;
    }

    // if (this.selected_page_data.afa_id != "" && this.selected_page_data.afa_id != null) {
    //   this.selected_page_data_errors.afa_id = false;
    // } else {
    //   this.selected_page_data_errors.afa_id = true;
    // }

    // if (this.selected_page_data.afa_comments != "" && this.selected_page_data.afa_comments != null) {
    //   this.selected_page_data_errors.afa_comments = false;
    // } else {
    //   this.selected_page_data_errors.afa_comments = true;
    // }

    if (
      (this.comment_data.comment_date != undefined &&
        this.comment_data.comment_date != '') ||
      this.comment_data.description != ''
    ) {
      if (
        this.comment_data.comment_date == undefined ||
        this.comment_data.comment_date == '' ||
        this.comment_data.comment_date == null
      ) {
        this.comment_data_errors.comment_date = true;
      } else {
        this.comment_data_errors.comment_date = false;
      }

      // if (this.comment_data.description == "" || this.comment_data.description == null) {
      //   this.comment_data_errors.description = true;
      // } else {
      //   this.comment_data_errors.description = false;
      // }

      if (
        this.comment_data_errors.comment_date == false &&
        // this.comment_data_errors.description == false &&
        this.page_operation_type == 'Edit'
      ) {
        this.saveComment();
      }
    } else {
      this.comment_data_errors.comment_date = false;
      this.comment_data_errors.description = false;
    }

    if (
      this.selected_page_data_errors.name == false &&
      // this.selected_page_data_errors.description == false &&
      this.selected_page_data_errors.due_date == false &&
      // this.selected_page_data_errors.actual_date == false &&
      this.selected_page_data_errors.status == false &&
      this.selected_page_data_errors.milestone_owner == false &&
      this.selected_page_data_errors.milestone_priority == false &&
      this.comment_data_errors.comment_date == false &&
      this.comment_data_errors.description == false
    ) {
      let payload: any = {
        name: this.selected_page_data.name,
        description: this.selected_page_data.description,
        due_date: moment(this.selected_page_data.due_date).format(),
        actual_date: moment(this.selected_page_data.actual_date).format(),
        milestone_owner: this.selected_page_data.milestone_owner,
        milestone_priority: this.selected_page_data.milestone_priority,
        status: this.selected_page_data.status,
        initiative: this.initiative_data.id,
      };

      if (
        this.selected_page_data.actual_date != undefined &&
        this.selected_page_data.actual_date != '' &&
        this.selected_page_data.actual_date != null
      ) {
        payload.actual_date = moment(
          this.selected_page_data.actual_date,
        ).format();
      } else {
        this.selected_page_data.actual_date = null;
        payload.actual_date = null;
      }

      if (this.page_operation_type == 'Add') {
        this.commonService.postData('/milestone/', payload).subscribe(
          (res: any) => {
            this.getMilestones();
            this.closeActivityOperationModal();
            this.commonService.showToast(
              'success',
              'Milestone Added Successfully.',
            );
          },
          (err) => {
            this.commonService.showToast('error', err.error);
          },
        );
      } else if (this.page_operation_type == 'Edit') {
        payload.id = this.selected_page_data.id;
        this.commonService
          .patch('/milestone/' + this.selected_page_data.id + '/', payload)
          .subscribe(
            (res: any) => {
              this.getMilestones();
              this.closeActivityOperationModal();
              this.commonService.showToast(
                'success',
                'Milestone Updated Successfully.',
              );
            },
            (err) => {
              this.commonService.showToast('error', err.error);
            },
          );
      }
    }
  }

  @ViewChild('activitiesDeleteModal') activitiesDeleteModal: TemplateRef<any>;
  private activitiesDeleteModalRef: MatDialogRef<TemplateRef<any>>;
  removeActivity(data, index) {
    this.selected_page_data = data;
    this.page_operation_index = index;
    this.activitiesDeleteModalRef = this.dialog.open(
      this.activitiesDeleteModal,
      { disableClose: true },
    );
    this.activitiesDeleteModalRef.afterClosed().subscribe((result) => {
      this.closeDeleteActivityModal();
    });
  }

  closeDeleteActivityModal() {
    this.resetModalData();
    this.activitiesDeleteModalRef.close();
  }

  deleteActivity() {
    this.commonService
      .delete('milestone/destroy?ids=' + this.selected_page_data.id)
      .subscribe(
        (res: any) => {
          // this.milestones_data.splice(this.page_operation_index, 1);
          this.getMilestones();
          this.closeDeleteActivityModal();
          this.commonService.showToast(
            'success',
            'Milestone Deleted Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  @ViewChild('commentsModal') commentsModal: TemplateRef<any>;
  private commentsModalRef: MatDialogRef<TemplateRef<any>>;
  openCommentsModal(data) {
    this.selected_page_data = data;
    this.commentsModalRef = this.dialog.open(this.commentsModal, {
      disableClose: true,
    });
    this.commentsModalRef.afterClosed().subscribe((result) => {
      this.closeCommentsModal();
    });
  }

  closeCommentsModal() {
    this.comment_data = {
      comment_date: '',
      description: '',
    };
    this.comment_data_errors = {
      comment_date: false,
      description: false,
    };
    this.commentsModalRef.close();
  }

  saveComment() {
    // if (this.comment_data.comment_date != "" && this.comment_data.comment_date != null) {
    //   this.comment_data_errors.comment_date = false;
    // } else {
    //   this.comment_data_errors.comment_date = true;
    // }

    // if (this.comment_data.description != "" && this.comment_data.description != null) {
    //   this.comment_data_errors.description = false;
    // } else {
    //   this.comment_data_errors.description = true;
    // }

    if (
      this.comment_data_errors.comment_date == false
      // &&
      // this.comment_data_errors.description == false
    ) {
      let payload: any = {
        comment_date: moment(this.comment_data.comment_date).format(),
        description: this.comment_data.description,
        milestone: this.selected_page_data.id,
      };

      let route: any = '';
      this.commonService.postData('/milestonecomments/', payload).subscribe(
        (res: any) => {
          this.selected_page_data.comments.push(res);
          // this.closeCommentsModal();
          this.commonService.showToast(
            'success',
            'Comment Added Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    }
  }

  deleteComment(data, comment, index) {
    let route: any = '';
    this.commonService
      .delete('/milestonecomments/destroy/?ids=' + comment.id)
      .subscribe(
        (res: any) => {
          data.splice(index, 1);
          this.comment_data = {
            comment_date: '',
            description: '',
          };
          this.comment_data_errors = {
            comment_date: false,
            description: false,
          };
          this.getMilestones();
          // this.closeCommentsModal();
          this.commonService.showToast(
            'success',
            'Comment Deleted Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  status_data: any = {
    appointment_status: '',
    appointment_reason: '',
  };
  status_data_errors: any = {
    appointment_status: false,
    appointment_reason: false,
  };
  @ViewChild('statusModal') statusModal: TemplateRef<any>;
  private statusModalRef: MatDialogRef<TemplateRef<any>>;
  openStatusModal(data) {
    this.status_data = JSON.parse(JSON.stringify(data));
    this.statusModalRef = this.dialog.open(this.statusModal, {
      disableClose: true,
    });
    this.statusModalRef.afterClosed().subscribe((result) => {
      this.closeStatusModal();
    });
  }

  closeStatusModal() {
    this.status_data = {
      appointment_status: '',
      appointment_reason: '',
    };
    this.status_data_errors = {
      appointment_status: false,
      appointment_reason: false,
    };
    this.statusModalRef.close();
  }

  saveStatus() {
    if (
      this.status_data.appointment_status != '' &&
      this.status_data.appointment_status != null
    ) {
      this.status_data_errors.appointment_status = false;
    } else {
      this.status_data_errors.appointment_status = false;
    }

    if (
      this.status_data.appointment_reason != '' &&
      this.status_data.appointment_reason != null
    ) {
      this.status_data_errors.appointment_reason = false;
    } else {
      this.status_data_errors.appointment_reason = false;
    }

    if (
      this.status_data_errors.appointment_status == false &&
      this.status_data_errors.appointment_reason == false
    ) {
      const payload = {
        appointment_status: this.status_data.appointment_status,
        appointment_reason: this.status_data.appointment_reason,
        id: this.status_data.id,
      };
      // this.commonService.postData("/changestatus/", payload).subscribe(
      //   (res: any) => {
      //     this.closeStatusModal();
      //     this.commonService.showToast("success", "Advisor Appointment Status Changed Successfully.");
      //   },
      //   (err) => {
      //     this.commonService.showToast("error", err.error);
      //   }
      // )
      this.commonService.patch('/advisor/' + payload.id, payload).subscribe(
        (res: any) => {
          this.getMilestones();
          this.closeStatusModal();
          this.commonService.showToast(
            'success',
            'Advisor Appointment Status Changed Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    }
  }

  show_milestone_tasks: number = null;
  toggleMilestoneTasksView(value) {
    if (this.show_milestone_tasks == value) {
      this.show_milestone_tasks = null;
    } else {
      this.show_milestone_tasks = value;
    }
  }
}
